export const CONTACT_COMPLIANCE_FIELDS_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  birthDate: 'Date of Birth',
  idType: 'ID Type',
  licenseExpiration: 'License Expiration',
  licenseNumber: 'License Number',
  licenseImage: 'License Photo',
  address1: 'Address1',
  phone1: 'Phone Number',
  email: 'Email Address',
}

export const VEHICLE_COMPLIANCE_FIELDS_MAP = {
  make: 'Vehicle Make',
  model: 'Vehicle Model',
  year: 'Vehicle Year',
  color: 'Vehicle Color',
  plateNumber: 'Vehicle Plate Number',
  plateState: 'Vehicle Plate State',
}

export const PAYMENT_COMPLIANCE_FIELDS_MAP = {
  signatureImageFileName: 'Signature',
  fingerPrintImageFileName: 'Fingerprint',
  contactImage: 'Customer Photo',
}

const convertFieldMapToArray = (fieldMap: { [key: string]: string }) => {
  return Object.entries(fieldMap).map(([key, value]) => ({
    id: key,
    name: value,
  }))
}

export const COMPLIANCE_FIELDS_ARRAY = [
  ...convertFieldMapToArray(CONTACT_COMPLIANCE_FIELDS_MAP),
  ...convertFieldMapToArray(VEHICLE_COMPLIANCE_FIELDS_MAP),
  ...convertFieldMapToArray(PAYMENT_COMPLIANCE_FIELDS_MAP),
]
